export default __webpack_public_path__ + "static/media/field_bg.3db02961.webp";